import { Form } from "formik";
import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { Card, CardBody, CardHeader, CardTitle, Col, Label, Row } from "reactstrap";
import { BlkField } from "../coms/BlkField";
import Alerts from "../util/Alerts";
import BlkFormik from "../coms/BlkFormik";
import { getDefaultBen, ListRedes, v_beneficio } from "./utils";
import axios from "axios";
import { routes } from "../gen/General";

export const EditBeneficio = props => {
    const [item, setItem] = useState({});
    const [asegs, setAsegs] = useState([]);
    const [planes, setPlanes] = useState([]);
    const [redesCoberturas, setRedesCoberturas] = useState([]);

    const alert = React.useRef(null);
    const history = useHistory();

    useEffect(() => {
        fetchRedesCoberturas();
        getAseguradora();
        if (props.match.params.id === "new") {
            setItem(getDefaultBen());
        } else {
            fetchData(props.match.params.id);
        }
    }, [props.match.params.id]);

    function getAseguradora() {
        axios
            .get(routes.base + "/aseguradora")
            .then(resp => {
                setAsegs(resp.data);
            })
            .catch(error => {
                alert.current.handle_error(error);
            });
    }

    function getPlanes() {
        axios
            .get(routes.base + "/planes")
            .then(resp => {
                setPlanes(resp.data);
            })
            .catch(error => {
                alert.current.handle_error(error);
            });
    }

    function fetchData(id) {
        axios
            .get(routes.base + "/beneficio", { params: { id } })
            .then(resp => {
                let it = resp.data;
                setItem(it);
            })
            .catch(error => {
                alert.current.handle_error(error);
            });
    }

    function onSubmit(newValues, actions) {
        newValues.fm = new Date();
        axios
            .post(routes.base + "/beneficio", newValues)
            .then(resp => {
                setItem(resp.data);
                alert.current.show_info("Guardado con éxito");
                setTimeout(() => {
                    history.push("/gen/beneficios");
                }, [1500]);
            })
            .catch(error => {
                alert.current.handle_error(error);
            })
            .finally(then => actions.setSubmitting(false));
    }

    const fetchRedesCoberturas = () => {
        axios
            .get(routes.base + "/red-coberturas")
            .then(resp => setRedesCoberturas(resp.data))
            .catch(err => err);
    };

    return (
        <div className="content">
            <Alerts ref={alert} />
            <Row>
                <Col xs={12}>
                    <Card>
                        <CardHeader>
                            <CardTitle className="text-center" tag="h4">
                                Beneficio
                            </CardTitle>
                        </CardHeader>
                        <CardBody>
                            <div className="container">
                                <BlkFormik
                                    initialValues={item}
                                    onSubmit={onSubmit}
                                    enableReinitialize={true}
                                    validateOnChange={false}
                                    validationSchema={v_beneficio}
                                >
                                    {({ isSubmitting, submitForm, values, setFieldValue }) => (
                                        <Form>
                                            <Row>
                                                <div className="form-group col-lg-6">
                                                    <Label>Aseguradora *</Label>
                                                    <BlkField
                                                        name="cdAseguradora"
                                                        className="form-control"
                                                        component={"select"}
                                                    >
                                                        <option value={""}>--Seleccione--</option>
                                                        {(asegs || []).map(a => (
                                                            <option key={a.cdAseguradora} value={a.cdAseguradora}>
                                                                {a.nmAseguradora}
                                                            </option>
                                                        ))}
                                                    </BlkField>
                                                </div>
                                                <div className="form-group col-lg-6">
                                                    <Label>Nombre de Red * </Label>
                                                    <BlkField
                                                        name="cdRedCob"
                                                        className="form-control"
                                                        component={"select"}
                                                    >
                                                        <option value={""}>--Seleccione--</option>
                                                        {(redesCoberturas || []).map(a => (
                                                            <option key={a.id} value={a.id}>
                                                                {a.red}
                                                            </option>
                                                        ))}
                                                    </BlkField>
                                                </div>
                                                <div className="form-group col-lg-6">
                                                    <Label>Red * </Label>
                                                    <BlkField name="red" className="form-control" component={"select"}>
                                                        <option value={""}>--Seleccione--</option>
                                                        {(ListRedes || []).map(a => (
                                                            <option key={a.id} value={a.id}>
                                                                {a.label}
                                                            </option>
                                                        ))}
                                                    </BlkField>
                                                </div>

                                                <div className="form-group col-lg-6">
                                                    <Label>Especialidad * </Label>
                                                    <BlkField name="especialidad" className="form-control" />
                                                </div>

                                                {values.red === "RED SELECTA" ? (
                                                    <>
                                                        <div className="form-group col-lg-6">
                                                            <Label>Protocolo </Label>
                                                            <BlkField name="protocolo" className="form-control" />
                                                        </div>
                                                        <div className="form-group col-lg-6">
                                                            <Label>Paquete </Label>
                                                            <BlkField name="paquete" className="form-control" />
                                                        </div>
                                                    </>
                                                ) : (
                                                    <>
                                                        {values.red !== "RED FARMACIA" && (
                                                            <div className="form-group col-lg-6">
                                                                <Label>Nombre Médico</Label>
                                                                <BlkField name="nombre" className="form-control" />
                                                            </div>
                                                        )}

                                                        <div className="form-group col-lg-6">
                                                            <Label>Nombre Proveedor </Label>
                                                            <BlkField name="nombreProveedor" className="form-control" />
                                                        </div>
                                                        {values.red === "RED FARMACIA" && (
                                                            <div className="form-group col-lg-6">
                                                                <Label>Punto de Venta </Label>
                                                                <BlkField name="puntoVenta" className="form-control" />
                                                            </div>
                                                        )}

                                                        <div className="form-group col-lg-6">
                                                            <Label>Ciudad </Label>
                                                            <BlkField name="ciudad" className="form-control" />
                                                        </div>
                                                        <div className="form-group col-lg-6">
                                                            <Label>Dirección </Label>
                                                            <BlkField name="direccion" className="form-control" />
                                                        </div>
                                                        <div className="form-group col-lg-6">
                                                            <Label>Teléfono </Label>
                                                            <BlkField name="telefono" className="form-control" />
                                                        </div>
                                                    </>
                                                )}
                                            </Row>
                                            <Row>
                                                <Col md={12}>
                                                    <Link to={"/gen/beneficios"} className="btn btn-secondary">
                                                        Atrás
                                                    </Link>
                                                    <button
                                                        type="button"
                                                        disabled={isSubmitting}
                                                        className="btn btn-primary mx-3"
                                                        onClick={submitForm}
                                                    >
                                                        Guardar
                                                    </button>
                                                </Col>
                                            </Row>
                                        </Form>
                                    )}
                                </BlkFormik>
                            </div>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </div>
    );
};
